import { SET_SOLR_CACHE } from '../actionTypes/CacheActionTypes';

/**
 * Reducer to handle the application cache settings
 */

export default function SOLRCacheReducer(state = {}, action) {
    switch (action.type) {
        case SET_SOLR_CACHE:
            return action.cache;
        default:
            return state;
    }
}
